var map = {
	"./example.png": 6254,
	"./game-choice-score.png": 8459,
	"./game-choice-scree.png": 2919,
	"./game-select.png": 9155,
	"./gatsby-icon.png": 518,
	"./group-creation-one.png": 1212,
	"./group-creation-two.png": 3406,
	"./group-selection.png": 1848,
	"./home.png": 3175,
	"./icons/albert.svg": 7886,
	"./icons/cherries.svg": 8535,
	"./icons/donut.svg": 7720,
	"./icons/mask.svg": 8348,
	"./icons/peach.svg": 4431,
	"./icons/tongue.svg": 4784,
	"./join.png": 3166,
	"./leadership-board.png": 564
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6133;